import { apiEnv } from '@mgmresorts/wcl-utils';
import React from 'react';

var BackdropContext = /*#__PURE__*/React.createContext({
  initialized: false,
  show: function show() {
    if (apiEnv === 'test') {
      return 'test';
    }

    throw new TypeError("BackdropContext isn't initialized");
  },
  hide: function hide() {
    if (apiEnv === 'test') {
      return;
    }

    throw new TypeError("BackdropContext isn't initialized");
  }
});

export { BackdropContext };
